<template>
  <div class="fill-height py-3 py-md-10">
    <v-container style="height: 100%;">
      <div style="height: 100%;" class="flex-center">
        <v-card
            v-if="$route.query.status === 'completed'"
            elevation="8"
            class="text-center flex-center card-success pa-7"
            max-width="700px"
        >
          <v-sheet color="transparent">
            <v-img
                contain
                class="mb-7"
                width="100%"
                max-width="200px"
                :src="imageSuccess"
            ></v-img>
            <div class="txt-large mb-1">
              Thank you!
            </div>
            <div class="grey--text txt-m-head mb-3">Your order has been paid.</div>
            <div class="grey--text text-decoration-underline pointer" @click="backToOrders">
              back to your orders ({{timeCount}}s)
            </div>
          </v-sheet>
        </v-card>
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "PaymentResult",
  data: () => ({
    timeCount: 15,
    interval: undefined,
    imageSuccess: require('../assets/img/success-icon.png')
  }),
  created () {
    switch (this.$route.query.status) {
      case 'canceled':
        this.$swal.fire({
          ...this.$swalError,
          text: 'Payment failure, please try again'
        })
        this.$router.push({ name: 'Home' })
        break

      case 'completed':
        this.interval = setInterval(() => {
          this.timeCount -= 1
          if (this.timeCount === 0) {
            this.backToOrders()
          }
        }, 1000)
        break

      default:
        this.$router.push({ name: 'Home' })
    }
  },
  methods: {
    backToOrders () {
      clearInterval(this.interval)
      this.$router.push({ name: 'MyOrders' })
    }
  }
}
</script>

<style scoped>
.card-success {
  border-radius: 16px;
  width: 100%;
  height: 100%;
  background: rgb(255,252,243);
  background: linear-gradient(180deg, rgba(255,252,243,1) 0%, rgba(255,255,255,1) 100%);
}
</style>
